import * as types from '../mutations'

const services = {
  user: window.abp.services.app.user
}

// initial state
const state = {
  all: [],
  pagination: {},
  activeUser: {}
}

// getters
const getters = {
  allUsers: state => state.all,
  allUsersPagination: state => state.pagination,
  activeUser: state => state.activeUser
}

// actions
const actions = {
  getUsers({ commit }, request) {
    if (!request) {
      request = {}
    }
    return new Promise((resolve, reject) => {
      services.user.getList(request).done(function (response) {
        let users = response.items
        let pagination = {
          currentPage: response.currentPage,
          totalCount: response.totalCount,
          totalPage: response.totalPage
        }
        commit(types.DATA.RECEIVE_USERS, { users, pagination })
        resolve()
      })
    })
  },
  getUser({ commit }, id) {
    let request = { id: id }
    return new Promise((resolve, reject) => {
      if (request.id === undefined) {
        commit(types.DATA.UPDATE_ACTIVE_USER, null)
        resolve()
      } else {
        services.user.get(request).done(function (response) {
          commit(types.DATA.UPDATE_ACTIVE_USER, response)
          resolve()
        })
      }
    })
  },
  createOrUpdateUser({ commit }, user) {
    return new Promise((resolve, reject) => {
      let action = user.id !== '' ? services.user.update(user) : services.user.create(user)
      action
        .done(function (response) {
          commit(types.DATA.REMOVE_VALIDATION_ERRORS)
          commit(types.DATA.UPDATE_ACTIVE_USER, response)
          resolve()
        })
        .fail(function (response) {
          commit(types.DATA.SET_VALIDATION_ERRORS, response)
          reject()
        })
    })
  },
  deleteUser({ commit }, id) {
    return new Promise((resolve, reject) => {
      services.user.delete({ id: id })
        .done(function (response) {
          commit(types.DATA.REMOVE_VALIDATION_ERRORS)
          commit(types.DATA.UPDATE_ACTIVE_USER, null)
          resolve()
        })
    })
  },
  resetPassword({ commit }, request) {
    return new Promise((resolve, reject) => {
      services.user.resetPassword(request)
        .done(function (response) {
          commit(types.DATA.REMOVE_VALIDATION_ERRORS)
          resolve()
        })
        .fail(function (response) {
          commit(types.DATA.SET_VALIDATION_ERRORS, response)
          reject(response.message)
        })
    })
  }
}

// mutations
const mutations = {
  [types.DATA.RECEIVE_USERS](state, { users, pagination }) {
    state.all = users
    state.pagination = pagination
  },
  [types.DATA.UPDATE_ACTIVE_USER](state, user) {
    state.activeUser = user
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./scripts/store/modules/users.js